'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.trackInteraction = trackInteraction;

var _getTracker = require('../selectors/getTracker');

var _eventProps = require('../selectors/eventProps');

function trackInteraction(eventName) {
  var properties = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return function (dispatch, getState) {
    var tracker = (0, _getTracker.getTracker)(getState());

    tracker.track(eventName, _extends({}, properties, (0, _eventProps.eventProps)(getState())));
  };
}


//////////////////
// WEBPACK FOOTER
// ./js/usage-tracking/actions/trackInteraction.js
// module id = 22
// module chunks = 2 3